export const spokesList = [
  {
    _id: '1',
    title: 'S1',
    description: 'S1',
    rewardType: 'cash',
    rewardValue: 10000,
    imageUrl: '',
    active: true
  },
  {
    _id: '2',
    title: 'S2',
    description: 'S2',
    rewardType: 'cash',
    rewardValue: 18000,
    imageUrl: '',
    active: true
  },
  {
    _id: '3',
    title: 'S3',
    description: 'S3',
    rewardType: 'cash',
    rewardValue: 70000,
    imageUrl: '',
    active: true
  },
  {
    _id: '4',
    title: 'S4',
    description: 'S4',
    rewardType: 'cash',
    rewardValue: 25000,
    imageUrl: '',
    active: true
  },
  {
    _id: '5',
    title: 'S5',
    description: 'S5',
    rewardType: 'cash',
    rewardValue: 20000,
    imageUrl: '',
    active: true
  },
  {
    _id: '6',
    title: 'S6',
    description: 'S6',
    rewardType: 'cash',
    rewardValue: 40000,
    imageUrl: '',
    active: true
  },
  {
    _id: '7',
    title: 'S7',
    description: 'S7',
    rewardType: 'cash',
    rewardValue: 15000,
    imageUrl: '',
    active: true
  },
  {
    _id: '8',
    title: 'S8',
    description: 'S8',
    rewardType: 'cash',
    rewardValue: 30000,
    imageUrl: '',
    active: true
  },
  {
    _id: '9',
    title: 'S9',
    description: 'S9',
    rewardType: 'cash',
    rewardValue: 21000,
    imageUrl: '',
    active: true
  },
  {
    _id: '10',
    title: 'S10',
    description: 'S10',
    rewardType: 'cash',
    rewardValue: 12000,
    imageUrl: '',
    active: true
  },
  {
    _id: '11',
    title: 'S11',
    description: 'S11',
    rewardType: 'cash',
    rewardValue: 14000,
    imageUrl: '',
    active: true
  },
  {
    _id: '12',
    title: 'S12',
    description: 'S12',
    rewardType: 'cash',
    rewardValue: 19000,
    imageUrl: '',
    active: true
  }
];
export const spinTheWheelGameUrl = 'https://games-dev.igamio.com/spin_the_wheel/';
